var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSmacAdmin)?_c('div',{attrs:{"id":"export-csv-container"}},[_c('button',{staticClass:"export-csv-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleActionModal(true, 'export-raw')}}},[_c('span',[_vm._v("Export CSV ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }